export default __webpack_public_path__ + "static/create-cohort-from-trend-light-mode-f98ea6fa980459af9b855f55b000b177.mp4";